import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import useAllClasses from "hooks/useAllClasses";
import type { Class } from "types/Class";

const ClassLabel = () => {
  const { id } = useParams();

  const { classes } = useAllClasses();

  const [currentClass, setCurrentClass] = useState<Class | null>(null);
  useEffect(() => {
    if (isNaN(parseInt(id || ""))) return;
    const currentClass = classes.find((c) => c.id === parseInt(id || ""));
    if (!currentClass) return;
    setCurrentClass(currentClass);
  }, [classes, id]);

  return (
    <div className="w-full lg:flex lg:justify-between lg:items-center space-y-2 lg:space-y-0">
      {currentClass && (
        <h2 className="text-xl font-semibold">{`${currentClass.year} - ${currentClass.name}`}</h2>
      )}
    </div>
  );
};

export default ClassLabel;
